var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCourseIconSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.43 155.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#176c4a;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:#219777;}.cls-7,.cls-9{fill:#fff;}.cls-8{clip-path:url(#clip-path-2);}.cls-9{opacity:0.5;}.cls-10{fill:#10849a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.16 118.17 110.5 58.47 190.61 97.54 98.27 157.24 18.16 118.17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 60.09,
    x2: 186.2,
    y2: 60.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dce35b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cde25d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#a8de60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#89db63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#71d966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#60d768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#56d669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53d669"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.44 73.48 74.26 38.04 143.19 71.66 88.37 107.1 19.44 73.48"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Microsoft Excel - Pivot Tables") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172,88.47l-61-29.73a15.15,15.15,0,0,0-3.5,1.63L25.17,113.64c-3.86,2.5-4.39,5.81-1.19,7.37L92.44,154.4c3.21,1.56,9,.81,12.84-1.69l63-40.71L172,88.47"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.2,32.51,121.6,1c-3.95-1.93-11.08-1-15.84,2.09L4.05,68.85C-.71,71.93-1.37,76,2.58,78L87.1,119.18c4,1.92,11.08,1,15.84-2.09l77.74-50.26,5.52-34.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M186.2,32.51l-25.26,20c-5,4-5.71,8.2-1.55,9.38l21,5.94,5.82-35.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.43,32.73l-24.2,10.48c-4.6,2-5.56,5.84-1.47,9.1l19.91,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M136.4,20.71,131,18.07l-10.71,3.48c-1.13.37-2.27.75-3.43,1.15L113.06,24l-.18-.08c.59-.88,1.13-1.67,1.64-2.39s1-1.41,1.45-2.11l4.51-6.5-5.67-2.77-9.12,14.58-26,7.53,5.41,2.64,11.57-3.59,3.76-1.26,4-1.38.18.09-1.73,2.49c-.53.76-1.07,1.53-1.6,2.31l-4.63,7,5.67,2.77L111.71,28l24.69-7.28"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.32,71.79l21.1-13.65L63.31,63,53.2,69.5l-11,7.11-9.89-4.82m47.76,7.74.09-1.11L92,76.55l-1.39,6.8-1.95.23.89-4.4-1.75,1.16c-4.83,3.22-7.27,4.84-10,5.21-2.38.32-4.24-.36-7.48-1.94-.64-.31-1.34-.66-2.09-1l-.33-.16-.46,4.34-2,.3.71-6.72L77.9,79.05l-.27,1.14L70.06,81l.33.16,2.12,1.06c2.57,1.25,4.19,1.89,5.51,1.71,1.57-.21,4-1.81,7.93-4.45l1.76-1.17-7.63,1.21M61.5,53.09l11.55-7.46,9.58,4.67L71.09,57.76,61.5,53.09m54.7,13.58L130,73.4l-11.91,7.69L76.73,60.92l11.9-7.69L102.41,60l13.79,6.72m27,5L74.26,38,19.44,73.48,88.37,107.1l54.82-35.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "129.99 73.4 116.2 66.67 104.3 74.37 90.51 67.64 102.41 59.95 88.63 53.23 76.73 60.92 118.08 81.09 129.99 73.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "116.2 66.67 102.41 59.95 90.51 67.64 104.3 74.37 116.2 66.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "63.31 62.97 53.42 58.14 32.32 71.79 42.21 76.61 32.32 71.79 43.31 64.68 53.2 69.5 63.31 62.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "53.2 69.5 43.31 64.68 32.32 71.79 42.21 76.61 53.2 69.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "82.63 50.3 73.05 45.63 61.5 53.09 71.09 57.77 82.63 50.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89.78,78l-2.07.32L86,79.49c-4,2.64-6.36,4.24-7.93,4.45-1.32.18-2.94-.46-5.51-1.71l-2.12-1.06L70.06,81l-2,.22-.13,1.17.33.16c.75.39,1.45.74,2.09,1,3.24,1.58,5.1,2.26,7.48,1.94,2.74-.37,5.18-2,10-5.21l1.75-1.16L89.78,78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "91.99 76.55 80.17 78.42 80.08 79.53 87.71 78.32 89.78 78 89.54 79.18 88.64 83.58 90.6 83.35 91.99 76.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "77.9 79.05 66.17 80.32 65.46 87.03 67.42 86.74 67.88 82.4 68.01 81.23 70.06 81.01 77.63 80.19 77.9 79.05"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCourseIconSchool);
export default __webpack_public_path__ + "static/media/new-course-icon-school.fea4b3b8e45e94d138706b5fb1983570.svg";
export { ForwardRef as ReactComponent };